module.exports = "/assets/creativecloudlogo-2e1fe6ce818ca3069d7613318fa1b285.png";